import { useState } from 'react';
import { CasRenderDate, CasTable } from 'src/compass/shared/components';
import ICasRenderCellProps from 'src/compass/shared/components/CasTable/ICasRenderCellProps';
import CasLink from 'src/compass/shared/components/CasLink/CasLink';

import ClaimDetailsDialog from '../shared/ClaimDetails/ClaimDetailsDialog';

export default function NoticeMissingTab() {
  const [dialogRowId, setDialogRowId] = useState<any>(null);
  const [reloadTable, setReloadTable] = useState<Date | null>(null);

  return (
    <>
      <CasTable
        entity="Sce/Claims/NoticeMissing"
        update={reloadTable}
        columnsSortable={false}
        includeExport={false}
        columns={[
          { field: 'endDate', render: CasRenderDate },
          {
            field: 'insuredName',
            render: ({ row }: ICasRenderCellProps) =>
              row?.endorsementId ? (
                <CasLink onClick={() => setDialogRowId(row.endorsementId)}>
                  {row.insuredName}
                </CasLink>
              ) : (
                row.insuredName
              ),
          },
          { field: 'reinsuranceYear' },
          { field: 'policyNumber', label: 'Policy#' },
          { field: 'sce' },
          { field: 'crop' },
          { field: 'cropEndDateReceived', render: CasRenderDate },
        ]}
        filters={[
          {
            name: 'insuredNameSearch',
            label: 'Insured Name',
            autoFocus: true
          },
        ]}
      />
      {dialogRowId && (
        <ClaimDetailsDialog
          id={dialogRowId}
          onClose={() => {
            setDialogRowId(null);
            setReloadTable(new Date());
          }}
        />
      )}
    </>
  );
}
